const NHSNumberOutput = props => {
    const value = props.value ?? props.question?.value ?? '';
    const numbersOnly = (value.match(/\d/g) || []).join('');
    return numbersOnly.replace(/^(.{3})(.{3})(.*)$/, '$1 $2 $3');
};

export default NHSNumberOutput;
